import { hertzColors } from './hertzColors';
import { createTheme } from '@mui/material';

export const appTheme = createTheme({
  palette: {
    primary: {
      light: hertzColors.lightBlack,
      main: hertzColors.black,
      dark: 'black',
    },
    secondary: {
      light: hertzColors.yellow,
      main: hertzColors.yellowDark,
    },
    error: {
      main: hertzColors.error,
      light: hertzColors.softError,
    },
    success: {
      main: hertzColors.success,
      light: hertzColors.softError,
    },
    warning: {
      main: hertzColors.warningText,
      light: hertzColors.warningBackground,
    },
  },
});
